import { createSlice } from '@reduxjs/toolkit';
import { OtherWebApi } from '../service/OtherWebApi';

interface IOtherWebApiStateSlice {
  tenantTaskData: any;
  currentAMMPage: number
}

const initialState: IOtherWebApiStateSlice = {
  tenantTaskData: {},
  currentAMMPage:1
  
};

export const OtherWebAPIStateSlice = createSlice({
  name: 'OtherWebAPIStateSlice',
  initialState,
  reducers: {
    setAMMCurrentPage(state, action: any) {
          state.currentAMMPage = action.payload;
        },
    
    },
    extraReducers: (builder) => {
        builder.addMatcher(OtherWebApi.endpoints.getAMMDashboardTaskList.matchFulfilled, (state, action) => {
        state.tenantTaskData = action?.payload;
        });
    },
});

export const { setAMMCurrentPage } = OtherWebAPIStateSlice.actions;
